import { Col, Grid, Row } from "antd";
import { Gutter } from "antd/es/grid/row";
import { CoachResponse } from "../../hooks/Coach/data";
import { CoachItem } from "./components";
import styles from "./styles.module.scss";

const CoachList = ({ coachList }: { coachList: CoachResponse[] }) => {
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();

  const getGutter = () => {
    if (screens.xl) return [43, 52];
    if (screens.lg) return [36, 52];
    if (screens.md) return [53, 52];
    if (screens.sm) return [20, 34];
    return [19, 24]; // Default for xs or smaller
  };

  const getFlex = () => {
    if (screens.xl) return "20%";
    if (screens.lg) return "25%";
    if (screens.md) return "33%";
    if (screens.sm) return "33%";
    return "50%"; // Default for xs or smaller
  };

  return (
    <div className={styles.coachList}>
      <Row gutter={getGutter() as [Gutter, Gutter]}>
        {coachList?.map((coach: CoachResponse, index: number) => (
          <Col style={{ width: getFlex() }} key={index}>
            <CoachItem data={coach} />
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default CoachList;
